var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import { createElement as _createElement } from "react";
import { useEffect, useState } from "react";
import { Autocomplete, Box, CircularProgress, TextField, Typography, } from "@mui/material";
import { searchUsers } from "../../api/usersAdminApi";
var shortId = function (id) {
    return id.length > 12 ? "".concat(id.slice(0, 6), "\u2026").concat(id.slice(-4)) : id;
};
var labelFor = function (o) { return o.username || o.nickname || o.id; };
// Автокомплит выбора автора коллекции: ищем по нику/ID, в подсказках показываем
// username + ID. Хранит в форме creatorId + отображаемое имя.
export var CreatorSelect = function (_a) {
    var valueId = _a.valueId, valueName = _a.valueName, onChange = _a.onChange, inputSx = _a.inputSx;
    var _b = useState(valueName), inputValue = _b[0], setInputValue = _b[1];
    var _c = useState([]), options = _c[0], setOptions = _c[1];
    var _d = useState(false), loading = _d[0], setLoading = _d[1];
    useEffect(function () {
        var q = inputValue.trim();
        if (q.length < 2)
            return;
        var cancelled = false;
        var timer = setTimeout(function () {
            setLoading(true);
            searchUsers(q)
                .then(function (res) {
                if (!cancelled)
                    setOptions(res);
            })
                .catch(function () {
                if (!cancelled)
                    setOptions([]);
            })
                .finally(function () {
                if (!cancelled)
                    setLoading(false);
            });
        }, 300);
        return function () {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [inputValue]);
    var selected = valueId
        ? { id: valueId, username: valueName || null, nickname: null, profilePictureImg: null }
        : null;
    return (_jsx(Autocomplete, { options: options, loading: loading, value: selected, isOptionEqualToValue: function (o, v) { return o.id === v.id; }, getOptionLabel: labelFor, filterOptions: function (x) { return x; }, noOptionsText: inputValue.trim().length < 2 ? "Введите минимум 2 символа" : "Никого не найдено", onChange: function (_, opt) {
            return onChange(opt ? { id: opt.id, name: labelFor(opt) } : { id: null, name: "" });
        }, inputValue: inputValue, onInputChange: function (_, val) { return setInputValue(val); }, renderOption: function (props, o) { return (_createElement(Box, __assign({ component: "li" }, props, { key: o.id }),
            _jsxs(Box, { sx: { display: "flex", flexDirection: "column", minWidth: 0 }, children: [_jsx(Typography, { sx: { color: "#fff", fontSize: 14 }, children: o.username || o.nickname || "—" }), _jsxs(Typography, { sx: { color: "rgba(255,255,255,0.45)", fontSize: 11 }, children: [o.nickname && o.username ? "".concat(o.nickname, " \u00B7 ") : "", "ID: ", shortId(o.id)] })] }))); }, renderInput: function (params) { return (_jsx(TextField, __assign({}, params, { label: "Creator / Author", placeholder: "\u0412\u0432\u0435\u0434\u0438\u0442\u0435 \u043D\u0438\u043A \u0438\u043B\u0438 ID \u043F\u043E\u043B\u044C\u0437\u043E\u0432\u0430\u0442\u0435\u043B\u044F", helperText: "\u041D\u0430\u0447\u043D\u0438\u0442\u0435 \u0432\u0432\u043E\u0434\u0438\u0442\u044C \u043D\u0438\u043A \u2014 \u043F\u043E\u044F\u0432\u044F\u0442\u0441\u044F \u043F\u043E\u0434\u0441\u043A\u0430\u0437\u043A\u0438 (\u043D\u0438\u043A + ID)", sx: inputSx, InputProps: __assign(__assign({}, params.InputProps), { endAdornment: (_jsxs(_Fragment, { children: [loading ? (_jsx(CircularProgress, { size: 16, sx: { color: "rgba(255,255,255,0.5)" } })) : null, params.InputProps.endAdornment] })) }) }))); } }));
};
export default CreatorSelect;
